import { fetchRequestWithTypes } from './index.js';

export const POST_TRUSTED_CONTACT_REQUEST = 'POST_TRUSTED_CONTACT_REQUEST';
export const POST_TRUSTED_CONTACT_SUCCESS = 'POST_TRUSTED_CONTACT_SUCCESS';
export const POST_TRUSTED_CONTACT_ERRORED = 'POST_TRUSTED_CONTACT_ERRORED';

export type TrustedContactRequestBody =
	| { opt_out: true }
	| {
			opt_out: false;
			first_name: string;
			last_name: string;
			email: string;
	  };

export const postTrustedContact = (body: TrustedContactRequestBody) =>
	fetchRequestWithTypes({
		types: [
			POST_TRUSTED_CONTACT_REQUEST,
			POST_TRUSTED_CONTACT_SUCCESS,
			POST_TRUSTED_CONTACT_ERRORED,
		],
		request: {
			method: 'POST',
			// Prefix `/apis` so local Vite proxies to edge (same as investor_application).
			path: '/apis/api/v1/users/:uuid/trusted_contacts',
			body,
		},
	});
